import React, { useState, useRef, useEffect } from 'react';
import styles from '../Admin/CSS/AdminPanel.module.css';

// Componente inteligente que detecta truncamiento en cualquier resolución
const EllipsisCell = ({ content }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const cellRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  // Función para comprobar si el contenido está truncado
  const checkTruncation = () => {
    if (cellRef.current) {
      const element = cellRef.current;
      setIsTruncated(element.scrollWidth > element.clientWidth);
    }
  };

  // Comprobar truncamiento inicial
  useEffect(() => {
    checkTruncation();
    
    // Volver a comprobar cuando cambie el tamaño de la ventana
    const handleResize = () => {
      checkTruncation();
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [content]);

  const handleMouseMove = (e) => {
    // Solo actualizar posición si está truncado
    if (isTruncated) {
      setTooltipPosition({
        x: e.clientX,
        y: e.clientY
      });
    }
  };

  const handleTouchMove = (e) => {
    // Solo manejar el evento si está truncado
    if (isTruncated && e.touches && e.touches[0]) {
      const touch = e.touches[0];
      setTooltipPosition({
        x: touch.clientX,
        y: touch.clientY
      });
    }
  };

  const handleInteractionStart = () => {
    // Comprobar truncamiento de nuevo al interactuar
    checkTruncation();
    // Solo mostrar tooltip si está truncado
    if (isTruncated) {
      setShowTooltip(true);
    }
  };

  return (
    <div
      ref={cellRef}
      className={`${styles.ellipsisCell} ${isTruncated ? styles.truncated : ''}`}
      style={{ 
        cursor: isTruncated ? 'pointer' : 'default',  // Cambiar 'help' por 'pointer'
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }}
      onMouseEnter={handleInteractionStart}
      onMouseLeave={() => setShowTooltip(false)}
      onMouseMove={handleMouseMove}
      onTouchStart={isTruncated ? handleInteractionStart : undefined}
      onTouchEnd={isTruncated ? () => setShowTooltip(false) : undefined}
      onTouchMove={isTruncated ? handleTouchMove : undefined}
    >
      {content}
      {showTooltip && isTruncated && (
        <div 
          style={{
            position: 'fixed',
            left: `${tooltipPosition.x}px`, 
            top: `${tooltipPosition.y - 40}px`,
            transform: 'translateX(-50%)',
            backgroundColor: '#333',
            color: 'white',
            padding: '8px 12px',
            borderRadius: '4px',
            fontSize: '14px',
            zIndex: 9999,
            whiteSpace: 'normal',
            maxWidth: 'auto',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
            pointerEvents: 'none'
          }}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default EllipsisCell;